// overlay-cart-drawer.js — AJAX add + open drawer with broad compatibility
(function () {
  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }


  onReady(function () {
    async function addToCartAjax(id, quantity) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: Number(id), quantity: Number(quantity || 1) })
      });
      if (!res.ok) throw new Error('add_failed');
      return res.json();
    }


    async function refreshCartCount() {
      try {
        const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        if (!r.ok) return;
        const cart = await r.json();
        document.querySelectorAll('[data-cart-count], .CartCount, .cart-count, .js-cart-count')
          .forEach(el => (el.textContent = cart.item_count));
      } catch (e) {}
    }


    function simulateClick(el) {
      if (!el) return false;
      try {
        const ev = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
        return el.dispatchEvent(ev);
      } catch (e) { return false; }
    }


    function dispatchCustomEvents() {
      const names = [
        'cart:open','open:cart','drawer:open','cart-drawer:open',
        'mini-cart:open','ajaxCart:open','theme:cart:open','cart:updated'
      ];
      names.forEach(n => {
        try { document.dispatchEvent(new CustomEvent(n, { bubbles: true })); } catch (e) {}
      });
    }


    function callKnownAPIs() {
      try { if (window.Vela && Vela.Cart && typeof Vela.Cart.open === 'function') { Vela.Cart.open(); return true; } } catch(e){}
      try { if (window.theme && theme.Cart && typeof theme.Cart.open === 'function') { theme.Cart.open(); return true; } } catch(e){}
      try { if (window.Shopify && Shopify.onItemAdded) { Shopify.onItemAdded(); } } catch(e){}
      return false;
    }


    function openDrawerSmart() {
      // 1) Custom events first (safe)
      dispatchCustomEvents();


      // 2) Known toggles/selectors (non-navigating)
      const preferredSelectors = [
        '[data-cart-toggle]',
        '[data-drawer-target="cart"]',
        '[data-drawer-trigger="cart"]',
        '[data-action="open-drawer"][data-drawer="cart"]',
        '.js-cart-toggle',
        '.js-drawer-open-cart',
        '.velaCart .cartToggle',
        '.miniCartToggle',
        '.cart-drawer-toggle',
        '[aria-controls*="cart"][aria-expanded]'
      ];
      for (const sel of preferredSelectors) {
        const el = document.querySelector(sel);
        if (simulateClick(el)) return true;
      }


      // 3) Try known APIs
      if (callKnownAPIs()) return true;


      // 4) Heuristic search for a header cart button that toggles a drawer
      const candidates = Array.from(document.querySelectorAll('a,button,[role="button"]')).filter(el => {
        const attrs = [el.className, el.id].concat(
          Array.from(el.attributes || [], a => `${a.name}=${a.value}`)
        ).join(' ').toLowerCase();


        const hasCart = /cart|mini-?cart|basket|bag/.test(attrs);
        const looksLikeToggle = /drawer|toggle|open|mini|side|panel|tray/.test(attrs) ||
                                el.hasAttribute('data-toggle') || el.hasAttribute('data-drawer');
        // avoid plain /cart links with no drawer hints
        const href = (el.getAttribute('href') || '').toLowerCase();
        const plainCartLink = href.startsWith('/cart') && !/#/.test(href) &&
                              !/drawer|toggle|ajax|open/.test(attrs + href);
        return hasCart && looksLikeToggle && !plainCartLink;
      });


      for (const el of candidates) {
        if (simulateClick(el)) return true;
      }


      // 5) Last-resort body class many themes watch
      document.body.classList.add('cart-drawer-open');
      return false;
    }


    // Intercept ONLY the overlay forms
    document.addEventListener('submit', function (e) {
      const form = e.target;
      if (!form.matches('.gridCartForm')) return;


      e.preventDefault();


      const fd = new FormData(form);
      const id = fd.get('id');
      const qty = fd.get('quantity') || 1;
      if (!id) return;


      const btn = form.querySelector('.gridCartBtn');
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }


      addToCartAjax(id, qty)
        .then(refreshCartCount)
        .then(openDrawerSmart)
        .catch(() => form.submit()) // if AJAX fails, fallback to theme default
        .finally(() => {
          if (btn) {
            btn.disabled = false;
            btn.classList.remove('is-loading');
            btn.classList.add('is-added');
            setTimeout(() => btn.classList.remove('is-added'), 1200);
          }
        });
    }, { passive: false });


    // Safety: ensure overlay button is a submit button
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.gridCartForm .gridCartBtn');
      if (!btn) return;
      if (btn.getAttribute('type') !== 'submit') btn.setAttribute('type', 'submit');
    });
  });
})();
